export const DEFAULT_AVATAR_URL = '/assets/images/user-information/default-avatar.svg';
export const LIST_DEFAULT_AVATAR = [
  '/assets/images/user-information/default-avatar/Group.svg',
  '/assets/images/user-information/default-avatar/Group-1.svg',
  '/assets/images/user-information/default-avatar/Group-2.svg',
  '/assets/images/user-information/default-avatar/Group-3.svg',
  '/assets/images/user-information/default-avatar/Group-4.svg',
  '/assets/images/user-information/default-avatar/Group-5.svg',
  '/assets/images/user-information/default-avatar/Group-6.svg',
  '/assets/images/user-information/default-avatar/Group-7.svg',
  '/assets/images/user-information/default-avatar/Group-8.svg',
];
export * from './origin-networks';
export * from './env';
export * from './data-key';
